import * as React from "react";
import {isMobile} from "react-device-detect";
import {useAddToCartQuery} from "../../../../hooks/useAddToCartQuery";
import {StandardProduct} from "./standardProduct";
import {MobileArtwork} from "./mobileArtwork";
import {DesignerProduct} from "./designerProduct";

export const AddToCart = () => {
    const {model: {isStandardProduct, isSmallScreenSize, isPurchasable}} = useAddToCartQuery();

    // Do not show 'add to cart' button when product is not purchasable
    if (!isPurchasable) return <></>

    // If the product is a standard product, return the standard product component
    if (isStandardProduct) return <StandardProduct/>;

    // If the user is on a mobile device, return the mobile artwork component
    if (isMobile || isSmallScreenSize) return <MobileArtwork/>;

    // Otherwise, return the designer product component
    return <DesignerProduct/>;
};